import withSuspense from "../../../../hocs/withSuspense";
import { ContactInfoError, ContactInfoSkeleton } from "../../components";
import {
  EditPhoneNumberPage,
  EditPhoneNumberPageProps,
} from "./EditPhoneNumberPage";

export const EditPhoneNumberPageWithSuspense =
  withSuspense<EditPhoneNumberPageProps>(EditPhoneNumberPage, {
    FallbackComponent: ContactInfoError,
    loading: <ContactInfoSkeleton rows={1} testId="edit-phone" />,
  });
